import { InvoiceButton, InvoiceButtonProps } from './InvoiceButton';
import { InvoiceStatusChips } from './InvoiceStatusChips';
import { InvoiceStatus } from '@/api/apis/case';
import { Uuid } from '@/api/types';

type InvoiceCellProps = {
  status: InvoiceStatus;
  id: Uuid;
  fileName: string;
  variant?: InvoiceButtonProps['variant'];
  onClick: (id: string) => void;
  columnKey: string;
};

export const renderInvoiceCell = ({ status, id, fileName, variant = 'sm', onClick, columnKey }: InvoiceCellProps) => {
  switch (columnKey) {
    case 'invoice':
      return (
        <div className="flex items-center border-r-1 border-base-70 h-full">
          <InvoiceButton fileName={fileName} variant={variant} onClickHandler={() => onClick(id)} />
        </div>
      );
    case 'status':
      return <InvoiceStatusChips status={status} />;
    default:
      return null;
  }
};
